<template>
  <VList class="bucket-settings-entries-component">
    <VListTile
      v-for="childRoute in routes"
      :key="childRoute.name"
      :to="{ name: childRoute.name }"
      class="child-link"
    >
      <VListTileAction>
        <KmIcon :name="childRoute.meta.icon" />
      </VListTileAction>
      <VListTileContent>
        <VListTileTitle>
          {{ childRoute.meta.title }}
        </VListTileTitle>
      </VListTileContent>
    </VListTile>
  </VList>
</template>

<script>
import { getRouteByName, isRouteUserFacing } from '@/utils/routeHelpers'
import KmIcon from '@/components/KmIcon'
import { SETTINGS_META_PAGE } from '@/router'
export default {
  name: 'BucketSettingsEntries',
  components: {
    KmIcon,
  },
  computed: {
    routes() {
      return getRouteByName(this.$router.options.routes, SETTINGS_META_PAGE).children.filter(
        route => isRouteUserFacing(route),
      )
    },
  },
}
</script>

<style lang="postcss" scoped></style>
